import { loadStripe } from "@stripe/stripe-js/pure";
import stripePublicApiToken from "./stripePublicApiToken";

const stripe = loadStripe(stripePublicApiToken).then((stripe) => stripe);

export default stripe;
